export default __webpack_public_path__ + "static/Content-image-525dceb44dc0c13cd4143afa785254c8.webp";